module.exports = __webpack_public_path__ + "img/checkmark.8b3269fe.svg";